import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBlocks: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBlocks"><Path d="M10.5 20.5V6.5H3.5V13.5M10.5 20.5H17.5V13.5H3.5M10.5 20.5H3.5V13.5" stroke="currentColor"/><Path d="M20.5 3.5H13.5V10.5H20.5V3.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconBlocks;
